"use client";

import React from "react";
import HealthcareDeskBanner from "@/components/pageComponent/healthcare/home/healthcareDeskBanner";
import LeverageMiles from "@/components/pageComponent/healthcare/home/leverageMiles";
import AmericanDream from "@/components/pageComponent/healthcare/home/americanDream";
// import GlobalHeader from "@/components/common/newCommonComponent/GlobalHeader";
import GlobalFooter from "@/components/common/newCommonComponent/GlobalFooter";
import GlobalHeaderNew from "@/components/common/newCommonComponent/GlobalHeaderNew";

const DesktopPage: React.FC = () => {
  return (
    <main className=" bg-white w-full">
      <GlobalHeaderNew />
      <HealthcareDeskBanner />
      <div id="leverage" className="w-full">
        <LeverageMiles />
      </div>
      <AmericanDream />
      <div className="w-full">
        <GlobalFooter />
      </div>
    </main>
  );
};

export default DesktopPage;
